import * as React from "react";
import { Checkbox, Input } from 'antd';

export default class CheckBoxInput extends React.Component<any> {

    // 值变化
    changeHandler = (value: any) => {
        const { onChange } = this.props;
        onChange && onChange({
            checkBox: value,
        });
    };

    changeInput = (inputValue: any) => {
        const { value, onBlur, onChange } = this.props;
        onBlur ? onBlur({ ...value, otherInput: inputValue }) : onChange && onChange({ ...value, otherInput: inputValue });
    };

    render() {
        let { options, value = {}, staticView, disabled } = this.props;
        const list = value.checkBox || [];
        const { otherInput } = value;
        const res = options.filter(({ value }: any) => list.includes(value));
        return <Checkbox.Group
            value={list}
            onChange={this.changeHandler}
            className='form-checkbox'
        >
            {(staticView && disabled)
                ? (list.length ? <div style={{wordBreak: 'keep-all'}}>{res.map((item: any, index: number) => {
                    return item.value === 'other'
                        ? <span key={item.value} style={{ marginRight: '10px'}}>({item.label}){value.otherInput || ''}</span>
                        : <span key={item.value} style={{ marginRight: '10px' }}>{item.label}{index === res.length-1 ? '' : ','}</span>;
                })}</div> : '-')
                : options.map((item: any) => {
                    return <div key={item.value} style={{ marginBottom: '8px' }}>
                        <Checkbox checked={list.includes(item.value)} value={item.value}>
                            {item.label}
                        </Checkbox>
                        {item.value === 'other' && list.includes('other') && <Input
                            onChange={(e) => this.changeInput(e.target.value)}
                            defaultValue={otherInput || ''}
                            />}
                    </div>;
                })
            }
        </Checkbox.Group>;
    }
}
